import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as area from './types';

const mutations = {
  [area.SET_AREA](state, data) {
    state.area.content = data.content;
    state.area.count = data.count;
  },

  [area.SET_MY_AREA](state, data) {
    state.myArea.current = data.current;
    state.myArea.nearby = data.nearby;
  },

  [area.AREA_RESET_STATE](state) {
    state.area = { content: [], count: 0 };
    state.myArea = {
      current: {},
      nearby: [],
    };
  },
};

export default mutations;
